import { render, staticRenderFns } from "./SubscriptionList.vue?vue&type=template&id=922c69fe&scoped=true&"
import script from "./SubscriptionList.vue?vue&type=script&lang=js&"
export * from "./SubscriptionList.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionList.vue?vue&type=style&index=0&id=922c69fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "922c69fe",
  null
  
)

export default component.exports